import React from 'react';
import { useDocsStore } from '../../store/docsStore';
import styles from './OfflineIndicator.module.css';

const CloudOffIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={styles.icon}
  >
    <path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </svg>
);

export const OfflineIndicator: React.FC = () => {
  const isOnline = useDocsStore((state) => state.isOnline);

  if (isOnline) {
    return null;
  }

  return (
    <div
      className={styles.offlineIndicator}
      title="You're offline - viewing cached documents"
    >
      <CloudOffIcon />
      <span className={styles.text}>Offline</span>
    </div>
  );
};
